import { Fragment, useCallback, useEffect, useState } from "react";

/* Marketing > Redes sociales: cuentas conectadas, publicaciones con métricas y ajustes de publicación. */

const API = "/api/marketing/redes";
const token = () => localStorage.getItem("token");
const AZUL = "#1565C0", MUTED = "#6b7280", BORDE = "#e5e7eb", VERDE = "#16a34a", AMBAR = "#d97706", ROJO = "#dc2626";
const FB = "#1877f2", IG = "linear-gradient(45deg,#f58529,#dd2a7b,#8134af)";

export async function apiRedes(ruta: string, opciones: { method?: string; body?: any } = {}) {
  const r = await fetch(API + ruta, {
    method: opciones.method || "GET",
    headers: { "Content-Type": "application/json", Authorization: "Bearer " + token() },
    body: opciones.body !== undefined ? JSON.stringify(opciones.body) : undefined,
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data?.detail || "No se pudo completar");
  return data;
}

const colones = (n: any) => "₡" + Math.round(Number(n) || 0).toLocaleString("es-CR").replace(/,/g, ".");

/** Arma el texto de la publicación con la plantilla (lo mismo que hace el backend). */
export function armarTexto(plantilla: string, p: { nombre?: string; precio?: any; precio_oferta?: any; descripcion?: string; categoria?: string }) {
  const precio = p.precio_oferta ? `${colones(p.precio_oferta)} (antes ${colones(p.precio)})` : colones(p.precio);
  const valores: any = { nombre: p.nombre || "", precio, descripcion: (p.descripcion || "").trim(), categoria: p.categoria || "", enlace: "https://importacionesby.com/catalogo" };
  let t = plantilla;
  Object.keys(valores).forEach(k => { t = t.split("{" + k + "}").join(valores[k]); });
  return t.replace(/\n{3,}/g, "\n\n").trim().slice(0, 2200);
}

const tarjeta: any = { background: "#fff", borderRadius: "16px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" };
const input: any = { padding: "9px 12px", border: "2px solid " + BORDE, borderRadius: "10px", fontSize: "14px", fontFamily: "Nunito,sans-serif", width: "100%", boxSizing: "border-box" };
const btn = (tipo: "normal" | "azul" = "normal"): any => ({
  border: "2px solid " + (tipo === "azul" ? AZUL : BORDE), background: tipo === "azul" ? AZUL : "#fff", color: tipo === "azul" ? "#fff" : "#1f2937",
  padding: "8px 14px", borderRadius: "10px", fontWeight: 800, fontSize: "13px", cursor: "pointer", fontFamily: "Nunito,sans-serif",
});
const fecha = (iso?: string) => iso ? new Date(iso).toLocaleString("es-CR", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "";
const Icono = ({ red }: { red: string }) => (
  <div style={{ width: "34px", height: "34px", borderRadius: "8px", display: "grid", placeItems: "center", color: "#fff", fontWeight: 900, flex: "none", background: red === "facebook" ? FB : IG }}>{red === "facebook" ? "f" : "◎"}</div>
);

/* ===================== CUENTAS ===================== */
const PERMISOS = "pages_show_list, pages_read_engagement, pages_manage_posts, read_insights, instagram_basic, instagram_content_publish, instagram_manage_insights, business_management";

function Cuentas() {
  const [cuentas, setCuentas] = useState<any>(null);
  const [conectando, setConectando] = useState(false);
  const [tok, setTok] = useState("");
  const [paginas, setPaginas] = useState<any>(null);
  const [aviso, setAviso] = useState("");
  const cargar = () => apiRedes("/cuentas").then(setCuentas).catch(() => {});
  useEffect(() => { cargar(); }, []);

  const buscarPaginas = async () => {
    setAviso("");
    try { setPaginas(await apiRedes("/conectar/paginas", { method: "POST", body: { token: tok } })); setTok(""); }
    catch (e: any) { setAviso("⚠️ " + e.message); }
  };
  const elegir = async (id: string) => {
    try {
      const r = await apiRedes("/conectar/elegir", { method: "POST", body: { clave: paginas.clave, pagina_id: id } });
      setAviso(`✓ Conectado: ${r.facebook}${r.instagram ? " y @" + r.instagram : " (esta Página no tiene Instagram de empresa vinculado)"}` + (r.token_permanente ? "" : ". ⚠️ Falta META_APP_SECRET en el .env: el token vencerá pronto."));
      setPaginas(null); setConectando(false); cargar();
    } catch (e: any) { setAviso("⚠️ " + e.message); }
  };
  const verificar = async () => {
    try { const r = await apiRedes("/cuentas/verificar", { method: "POST" }); setAviso(Object.values(r).every(Boolean) ? "✓ La conexión funciona" : "⚠️ Hay un problema con la conexión: vuelva a conectar"); cargar(); }
    catch (e: any) { setAviso("⚠️ " + e.message); }
  };
  const desconectar = async () => {
    if (!window.confirm("¿Desconectar Facebook e Instagram? Las publicaciones automáticas se detendrán.")) return;
    await apiRedes("/cuentas", { method: "DELETE" }).catch(() => {}); cargar();
  };

  if (!cuentas) return <div style={{ color: MUTED }}>Cargando…</div>;
  const hay = cuentas.facebook || cuentas.instagram;
  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))", gap: "12px", marginBottom: "16px" }}>
        {["facebook", "instagram"].map(red => {
          const c = cuentas[red];
          return (
            <div key={red} style={{ ...tarjeta, padding: "16px", display: "flex", gap: "12px", alignItems: "center" }}>
              <Icono red={red} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 800 }}>{red === "facebook" ? "Facebook" : "Instagram"}</div>
                <div style={{ fontSize: "13px", color: MUTED, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c ? c.nombre : "Sin conectar"}</div>
                {c?.ultimo_error && <div style={{ fontSize: "12px", color: ROJO }}>⚠️ {c.ultimo_error}</div>}
              </div>
              <span style={{ fontSize: "12px", fontWeight: 800, padding: "3px 8px", borderRadius: "20px", background: c ? "#ECFDF5" : "#f3f4f6", color: c ? VERDE : MUTED }}>{c ? "● Conectada" : "—"}</span>
            </div>
          );
        })}
      </div>
      <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "12px" }}>
        <button style={btn("azul")} onClick={() => { setConectando(!conectando); setPaginas(null); setAviso(""); }}>{hay ? "🔄 Conectar otra vez / cambiar Página" : "🔗 Conectar Página e Instagram"}</button>
        {hay && <button style={btn()} onClick={verificar}>Verificar conexión</button>}
        {hay && <button style={btn()} onClick={desconectar}>Desconectar</button>}
      </div>
      {aviso && <div style={{ padding: "10px 14px", borderRadius: "10px", marginBottom: "12px", fontSize: "14px", background: aviso.startsWith("⚠️") ? "#FEF2F2" : "#ECFDF5", color: aviso.startsWith("⚠️") ? "#991b1b" : "#166534" }}>{aviso}</div>}

      {conectando && (
        <div style={{ ...tarjeta, padding: "18px" }}>
          {!paginas ? (<>
            <div style={{ fontWeight: 800, marginBottom: "6px" }}>Conectar (lo hace Nova)</div>
            <ol style={{ fontSize: "13px", color: "#374151", paddingLeft: "18px", margin: "0 0 12px", lineHeight: 1.6 }}>
              <li>Con la cuenta de Facebook que administra la Página, entre a <a href="https://developers.facebook.com/tools/explorer/" target="_blank" rel="noreferrer" style={{ color: AZUL }}>Explorador de la API Graph</a>.</li>
              <li>Arriba a la derecha elija la app <b>Nova Connect</b> y "Token de usuario".</li>
              <li>En permisos agregue: <code style={{ fontSize: "12px", background: "#f3f4f6", padding: "1px 4px", borderRadius: "4px" }}>{PERMISOS}</code></li>
              <li>Clic en <b>Generate Access Token</b>, acepte y copie el token.</li>
            </ol>
            <div style={{ display: "flex", gap: "8px" }}>
              <input type="password" style={input} placeholder="Pegue aquí el token (empieza con EAA)" value={tok} onChange={e => setTok(e.target.value)} />
              <button style={btn("azul")} disabled={!tok.trim()} onClick={buscarPaginas}>Buscar Páginas</button>
            </div>
            <div style={{ fontSize: "12px", color: MUTED, marginTop: "6px" }}>El token se usa una sola vez para obtener el de la Página, que se guarda cifrado.</div>
          </>) : (<>
            <div style={{ fontWeight: 800, marginBottom: "8px" }}>¿Qué Página quiere conectar?</div>
            {paginas.paginas.map((p: any) => (
              <div key={p.id} style={{ display: "flex", gap: "12px", alignItems: "center", padding: "10px", border: "2px solid " + BORDE, borderRadius: "12px", marginBottom: "8px" }}>
                {p.foto ? <img src={p.foto} alt="" style={{ width: "40px", height: "40px", borderRadius: "50%" }} /> : <Icono red="facebook" />}
                <div style={{ flex: 1 }}><div style={{ fontWeight: 800 }}>{p.nombre}</div><div style={{ fontSize: "13px", color: MUTED }}>{p.instagram ? "Instagram: @" + p.instagram : "Sin Instagram de empresa vinculado"}</div></div>
                <button style={btn("azul")} onClick={() => elegir(p.id)}>Conectar</button>
              </div>
            ))}
          </>)}
        </div>
      )}
    </div>
  );
}

/* ===================== PUBLICACIONES ===================== */
function Publicaciones() {
  const [lista, setLista] = useState<any[] | null>(null);
  const [productos, setProductos] = useState<any[]>([]);
  const [cfg, setCfg] = useState<any>(null);
  const [nuevo, setNuevo] = useState<any>({ producto_id: "", texto: "", redes: [] as string[] });
  const [aviso, setAviso] = useState("");
  const [abierto, setAbierto] = useState<number | null>(null);

  const cargar = useCallback(() => apiRedes("/publicaciones").then(setLista).catch(() => setLista([])), []);
  useEffect(() => {
    cargar();
    fetch("/api/productos/").then(r => r.json()).then(d => Array.isArray(d) && setProductos(d)).catch(() => {});
    apiRedes("/config").then(c => { setCfg(c); setNuevo((n: any) => ({ ...n, redes: c.redes })); }).catch(() => {});
  }, [cargar]);
  useEffect(() => {  // mientras haya publicaciones en curso, se actualiza sola
    if (!lista?.some(p => p.estado === "pendiente" || p.estado === "publicando")) return;
    const t = setTimeout(cargar, 4000); return () => clearTimeout(t);
  }, [lista, cargar]);

  const elegirProducto = async (id: string) => {
    setNuevo((n: any) => ({ ...n, producto_id: id, texto: "" }));
    if (!id) return;
    try { const v = await apiRedes(`/vista-previa/${id}`); setNuevo((n: any) => ({ ...n, texto: v.texto, fotos: v.fotos.length })); } catch { /* sin vista previa */ }
  };
  const publicar = async () => {
    setAviso("");
    try { const r = await apiRedes(`/publicar/${nuevo.producto_id}`, { method: "POST", body: { redes: nuevo.redes, texto: nuevo.texto } }); setAviso(`✓ Publicando en ${r.redes.join(" y ")}…`); setNuevo({ producto_id: "", texto: "", redes: cfg?.redes || [] }); cargar(); }
    catch (e: any) { setAviso("⚠️ " + e.message); }
  };
  const reintentar = async (id: number) => { await apiRedes(`/publicaciones/${id}/reintentar`, { method: "POST" }).catch(() => {}); cargar(); };
  const metricas = async () => { await apiRedes("/metricas/actualizar", { method: "POST" }).catch(() => {}); setAviso("✓ Actualizando métricas… recargue en unos segundos"); setTimeout(cargar, 5000); };

  const estadoTag = (p: any) => {
    const m: any = { publicado: ["Publicado", "#ECFDF5", VERDE], pendiente: ["En cola", "#f3f4f6", MUTED], publicando: ["Publicando…", "#EFF6FF", AZUL], error: ["Error", "#FEF2F2", ROJO] };
    const [t, bg, c] = m[p.estado] || [p.estado, "#f3f4f6", MUTED];
    return <span style={{ fontSize: "12px", fontWeight: 800, padding: "2px 8px", borderRadius: "20px", background: bg, color: c }}>{t}</span>;
  };
  const num = (v: any) => v === null || v === undefined ? "—" : Number(v).toLocaleString("es-CR");

  return (
    <div>
      <div style={{ ...tarjeta, padding: "16px", marginBottom: "16px" }}>
        <div style={{ fontWeight: 800, marginBottom: "8px" }}>Publicar un producto ahora</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))", gap: "12px" }}>
          <div style={{ display: "grid", gap: "8px", alignContent: "start" }}>
            <select style={input} value={nuevo.producto_id} onChange={e => elegirProducto(e.target.value)}>
              <option value="">Elija un producto…</option>
              {productos.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
            </select>
            <div style={{ display: "flex", gap: "16px", fontSize: "14px" }}>
              {["facebook", "instagram"].map(r => (
                <label key={r} style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                  <input type="checkbox" checked={nuevo.redes.includes(r)} onChange={e => setNuevo({ ...nuevo, redes: e.target.checked ? [...nuevo.redes, r] : nuevo.redes.filter((x: string) => x !== r) })} />
                  {r === "facebook" ? "Facebook" : "Instagram"}
                </label>))}
            </div>
            {nuevo.producto_id && nuevo.fotos === 0 && <div style={{ fontSize: "13px", color: ROJO }}>⚠️ Este producto no tiene fotos: agréguelas en Productos.</div>}
            <button style={btn("azul")} disabled={!nuevo.producto_id || !nuevo.redes.length} onClick={publicar}>📣 Publicar</button>
          </div>
          <textarea style={{ ...input, minHeight: "130px", resize: "vertical" }} placeholder="El texto se arma con la plantilla; puede editarlo antes de publicar." value={nuevo.texto} onChange={e => setNuevo({ ...nuevo, texto: e.target.value })} />
        </div>
        {aviso && <div style={{ marginTop: "10px", fontSize: "13px", color: aviso.startsWith("⚠️") ? "#991b1b" : VERDE }}>{aviso}</div>}
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px", flexWrap: "wrap", gap: "8px" }}>
        <div style={{ fontWeight: 800 }}>Publicaciones recientes</div>
        <button style={btn()} onClick={metricas}>🔄 Actualizar métricas</button>
      </div>
      <div style={{ ...tarjeta, overflowX: "auto" }}>
        {lista === null ? <div style={{ padding: "20px", color: MUTED }}>Cargando…</div> : lista.length === 0 ? (
          <div style={{ padding: "50px", textAlign: "center", color: "#9ca3af" }}>Todavía no hay publicaciones</div>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px", minWidth: "720px" }}>
            <thead><tr>{["Producto", "Red", "Fecha", "Estado", "Alcance", "Me gusta", "Comentarios", ""].map(h => <th key={h} style={{ textAlign: "left", padding: "10px 12px", fontSize: "12px", color: MUTED, textTransform: "uppercase", borderBottom: "1px solid " + BORDE }}>{h}</th>)}</tr></thead>
            <tbody>
              {lista.map(p => (<Fragment key={p.id}>
                <tr key={p.id} style={{ borderBottom: "1px solid " + BORDE, cursor: "pointer" }} onClick={() => setAbierto(abierto === p.id ? null : p.id)}>
                  <td style={{ padding: "10px 12px", fontWeight: 700 }}>{p.producto}</td>
                  <td style={{ padding: "10px 12px" }}>{p.red === "facebook" ? "Facebook" : "Instagram"}</td>
                  <td style={{ padding: "10px 12px", color: MUTED }}>{fecha(p.creado_en)}</td>
                  <td style={{ padding: "10px 12px" }}>{estadoTag(p)}</td>
                  <td style={{ padding: "10px 12px" }}>{num(p.alcance)}</td>
                  <td style={{ padding: "10px 12px" }}>{num(p.me_gusta)}</td>
                  <td style={{ padding: "10px 12px" }}>{num(p.comentarios)}</td>
                  <td style={{ padding: "10px 12px", whiteSpace: "nowrap" }} onClick={e => e.stopPropagation()}>
                    {p.enlace && <a href={p.enlace} target="_blank" rel="noreferrer" style={{ color: AZUL, fontWeight: 700, fontSize: "13px" }}>Ver ↗</a>}
                    {p.estado === "error" && <button style={{ ...btn(), padding: "4px 10px" }} onClick={() => reintentar(p.id)}>Reintentar</button>}
                  </td>
                </tr>
                {abierto === p.id && (
                  <tr key={p.id + "-d"}><td colSpan={8} style={{ padding: "10px 12px 16px", background: "#fafafa", borderBottom: "1px solid " + BORDE }}>
                    {p.error && <div style={{ color: "#991b1b", fontSize: "13px", marginBottom: "6px" }}>⚠️ {p.error}</div>}
                    <div style={{ whiteSpace: "pre-wrap", fontSize: "13px", color: "#374151" }}>{p.texto}</div>
                    {p.metricas_en && <div style={{ fontSize: "12px", color: MUTED, marginTop: "6px" }}>Métricas actualizadas: {fecha(p.metricas_en)}</div>}
                  </td></tr>
                )}
              </Fragment>))}
            </tbody>
          </table>
        )}
      </div>
      <p style={{ fontSize: "12px", color: MUTED }}>Las métricas se actualizan solas cada 6 horas durante los primeros 30 días. El alcance puede tardar unas horas en aparecer.</p>
    </div>
  );
}

/* ===================== AJUSTES ===================== */
const EJEMPLO = { nombre: "Freidora de aire 5L", precio: 39900, precio_oferta: 34900, descripcion: "Cocina sin aceite, 8 funciones y 6 meses de garantía.", categoria: "Cocina" };

function AjustesRedes() {
  const [cfg, setCfg] = useState<any>(null);
  const [plantilla, setPlantilla] = useState("");
  const [guardado, setGuardado] = useState("");
  useEffect(() => { apiRedes("/config").then(c => { setCfg(c); setPlantilla(c.plantilla); }).catch(() => {}); }, []);
  const guardar = async (cambios: any) => {
    try { const c = await apiRedes("/config", { method: "PUT", body: cambios }); setCfg(c); setGuardado("✓ Guardado"); setTimeout(() => setGuardado(""), 2000); }
    catch { setGuardado("⚠️ No se pudo guardar"); }
  };
  const insertar = (v: string) => setPlantilla(p => p + v);
  if (!cfg) return <div style={{ color: MUTED }}>Cargando…</div>;
  return (
    <div style={{ ...tarjeta, padding: "18px" }}>
      <label style={{ display: "flex", justifyContent: "space-between", gap: "16px", alignItems: "center", paddingBottom: "14px", borderBottom: "1px solid " + BORDE, cursor: "pointer", flexWrap: "wrap" }}>
        <div><div style={{ fontWeight: 800 }}>Publicar productos nuevos</div><div style={{ fontSize: "13px", color: MUTED }}>Al crear un producto, la casilla "Publicar en redes" viene marcada.</div></div>
        <input type="checkbox" checked={cfg.auto_publicar} onChange={e => guardar({ auto_publicar: e.target.checked })} style={{ width: "20px", height: "20px" }} />
      </label>
      <div style={{ padding: "14px 0", borderBottom: "1px solid " + BORDE, display: "flex", justifyContent: "space-between", gap: "16px", flexWrap: "wrap" }}>
        <div><div style={{ fontWeight: 800 }}>Redes donde se publica</div><div style={{ fontSize: "13px", color: MUTED }}>Se puede cambiar en cada producto.</div></div>
        <div style={{ display: "flex", gap: "16px" }}>
          {["facebook", "instagram"].map(r => (
            <label key={r} style={{ display: "flex", gap: "6px", alignItems: "center", fontSize: "14px" }}>
              <input type="checkbox" checked={cfg.redes.includes(r)} onChange={e => guardar({ redes: e.target.checked ? [...cfg.redes, r] : cfg.redes.filter((x: string) => x !== r) })} />
              {r === "facebook" ? "Facebook" : "Instagram"}
            </label>))}
        </div>
      </div>
      <div style={{ paddingTop: "14px" }}>
        <div style={{ fontWeight: 800, marginBottom: "8px" }}>Texto de la publicación</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))", gap: "16px" }}>
          <div>
            <textarea style={{ ...input, minHeight: "180px", resize: "vertical" }} value={plantilla} onChange={e => setPlantilla(e.target.value)} />
            <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginTop: "8px" }}>
              {[["{nombre}", "Nombre"], ["{precio}", "Precio"], ["{descripcion}", "Descripción"], ["{categoria}", "Categoría"], ["{enlace}", "Enlace"]].map(([v, l]) => (
                <button key={v} onClick={() => insertar(v)} style={{ fontSize: "12px", background: "#EFF6FF", color: AZUL, border: 0, borderRadius: "20px", padding: "4px 10px", cursor: "pointer", fontWeight: 700 }}>+ {l}</button>))}
            </div>
            <div style={{ display: "flex", gap: "8px", alignItems: "center", marginTop: "10px" }}>
              <button style={btn("azul")} onClick={() => guardar({ plantilla })}>Guardar texto</button>
              <span style={{ fontSize: "13px", color: guardado.startsWith("⚠️") ? ROJO : VERDE }}>{guardado}</span>
            </div>
          </div>
          <div>
            <div style={{ fontSize: "12px", color: MUTED, marginBottom: "6px" }}>Vista previa</div>
            <div style={{ border: "1px solid " + BORDE, borderRadius: "12px", overflow: "hidden" }}>
              <div style={{ display: "flex", gap: "8px", alignItems: "center", padding: "10px", fontWeight: 700, fontSize: "13px" }}><div style={{ width: "26px", height: "26px", borderRadius: "50%", background: AZUL }} />Importaciones B&Y</div>
              <div style={{ height: "120px", background: "linear-gradient(135deg,#dfe7f3,#c9d6ea)", display: "grid", placeItems: "center", color: MUTED, fontSize: "13px" }}>Foto del producto</div>
              <div style={{ padding: "10px", fontSize: "13px", whiteSpace: "pre-wrap" }}>{armarTexto(plantilla, EJEMPLO)}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Redes() {
  const [tab, setTab] = useState("pub");
  const p = (k: string, l: string) => (
    <button key={k} onClick={() => setTab(k)} style={{ border: "2px solid " + (tab === k ? AZUL : BORDE), background: tab === k ? AZUL : "#fff", color: tab === k ? "#fff" : MUTED, padding: "9px 16px", borderRadius: "50px", fontWeight: 700, fontSize: "14px", cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>{l}</button>
  );
  return (
    <div>
      <div style={{ display: "flex", gap: "6px", marginBottom: "16px", flexWrap: "wrap" }}>
        {p("pub", "📊 Publicaciones")}{p("cuentas", "🔗 Cuentas")}{p("aj", "⚙️ Ajustes")}
      </div>
      {tab === "pub" && <Publicaciones />}
      {tab === "cuentas" && <Cuentas />}
      {tab === "aj" && <AjustesRedes />}
      <p style={{ fontSize: "12px", color: AMBAR, marginTop: "12px" }}>Las fotos se convierten a JPG automáticamente. Si hay varias fotos se publica un carrusel (máximo 10).</p>
    </div>
  );
}
